module.exports = __webpack_public_path__ + "img/fairy.0d1a44b3.gif";